import CurrencyFormatter from './currency-formatter';

function getFormattedDiscountPrice(prices, rounded = false) {
    if (!prices?.discount) {
        return false;
    }
    return rounded
        ? CurrencyFormatter.formattedRoundedNumber(prices.discount?.centValue)
        : CurrencyFormatter.formattedPrice(prices.discount?.centValue);
}
function getSalePriceValue(prices) {
    return prices?.sale?.centValue;
}

function getFormattedSalePrice(prices) {
    const salePriceValue = getSalePriceValue(prices);
    return CurrencyFormatter.formattedPrice(salePriceValue);
}

function getFormattedStrikePrice(prices) {
    if (!prices?.strike) {
        return false;
    }
    return CurrencyFormatter.formattedNumber(prices?.strike?.centValue);
}

function getFormattedBasePrice(prices) {
    if (!prices?.base || !prices?.base?.centValue > 0) return '';
    return `${CurrencyFormatter.formattedPrice(prices.base.centValue)}/${prices.base.unit}`;
}

function isStrikePrice(prices) {
    if (!prices?.strike) {
        return false;
    }
    return prices?.strike.type === 'UVP';
}

function isPartialPrice(prices) {
    if (!prices?.discount) {
        return false;
    }
    return prices?.discount?.type === 'PARTIAL';
}

function isFromPrice(prices) {
    if (!prices?.sale) {
        return false;
    }
    return prices?.sale?.type === 'FROM' ?? false;
}

export {
    getFormattedDiscountPrice,
    getFormattedSalePrice,
    getFormattedStrikePrice,
    getSalePriceValue,
    getFormattedBasePrice,
    isStrikePrice,
    isPartialPrice,
    isFromPrice,
};
